import { useCallback, useState } from 'react'

export const useGetSocialThumbnail = (projectId, userId) => {
  const [isLoading, setIsLoading] = useState(false)
  const getSocialThumbnail = useCallback(
    async (url: string) => {
      try {
        setIsLoading(true)
        const res = await fetch(
          `/api/social-thumbnail?url=${url}&projectId=${projectId}&userId=${userId}`,
          {
            credentials: 'include',
          }
        )

        setIsLoading(false)

        if (res.status >= 400) {
          return false
        }

        const data = await res.blob()
        return data
      } catch (e) {
        setIsLoading(false)
        return false
      }
    },
    [projectId, userId]
  )
  return { getSocialThumbnail, isLoading }
}
